module.exports = __webpack_public_path__ + "img/parking-garage.42c435b4.jpg";